import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isVideoModalOpen: false,
    videoFormData: {}
};

const videosSlice = createSlice({
    name: "videos",
    initialState,
    reducers: {
        toggleVideoModal: (state, action) => {
            const isVideoModalOpen = action.payload;
            state.isVideoModalOpen = isVideoModalOpen;
            if (!isVideoModalOpen) {
                state.videoFormData = {}
            }
        },
        getVideoFormData: (state, action) => {
            state.videoFormData = action.payload;
        }
    },
});

export const { toggleVideoModal, getVideoFormData } = videosSlice.actions;
export default videosSlice.reducer;
